import CoreAPI from "../coreAPI";
import { Plan, PlanAPIResponse } from "../../classes/employerDashboard/plan";
import { PlanAdministrator, PlanAdministratorResponse } from "../../classes/employerDashboard/planAdministrator";

export default function APIPlan(coreAPI: CoreAPI) {
  const api = {
    async getRecordKeeperList() {
      try {
        const response = await coreAPI.authCall<{ staticDataList: string[] }>({
          endpoint: `/providerName`,
        });
        return response.staticDataList;
      } catch (e) {
        return [];
      }
    },
    async getAllPlans() {
      try {
        const response = await coreAPI.authCall<PlanAPIResponse[]>({
          endpoint: `/tenant/plans`,
        });
        return response.map((plan) => Plan.fromAPI(plan));
      } catch (e) {
        return [];
      }
    },
    async getPlanAdministrator() {
      try {
        const response = await coreAPI.authCall<PlanAdministratorResponse>({
          endpoint: `/tenant/planAdministrator`,
        });
        return PlanAdministrator.fromAPI(response);
      } catch (e) {
        return null;
      }
    },
    async createPlanAdministrator(planAdministrator: PlanAdministrator) {
      const response = await coreAPI.authCall<PlanAdministratorResponse>({
        method: "POST",
        endpoint: `/planAdministrator`,
        body: planAdministrator.toJSONForAPI(),
      });
      return PlanAdministrator.fromAPI(response);
    },
    async updatePlanAdministrator(planAdministrator: PlanAdministrator) {
      if (planAdministrator.planAdministratorId === -1) return api.createPlanAdministrator(planAdministrator);
      const response = await coreAPI.authCall<PlanAdministratorResponse>({
        method: "PATCH",
        endpoint: `/planAdministrator/${planAdministrator.planAdministratorId}`,
        body: planAdministrator.toJSONForAPI(),
      });
      return PlanAdministrator.fromAPI(response);
    },
    async createPlan(plan: Plan) {
      const response = await coreAPI.authCall<PlanAPIResponse>({
        method: "POST",
        endpoint: "/plan",
        body: plan.toJSONForAPI(),
      });
      return Plan.fromAPI(response);
    },
    async updatePlan(plan: Plan) {
      if (plan.planId === -1) return api.createPlan(plan);
      const response = await coreAPI.authCall<PlanAPIResponse>({
        method: "PUT",
        endpoint: `/plan/${plan.planId}`,
        body: plan.toJSONForAPI(),
      });
      return Plan.fromAPI(response);
    },
    async removePlan(plan: Plan) {
      await coreAPI.authCall({
        method: "DELETE",
        endpoint: `/plan/${plan.planId}`,
      });
      return true;
    },
    async removePlanDocument(params: { planId: number; fileName: string }) {
      const { planId, fileName } = params;

      await coreAPI.authCall({
        method: "DELETE",
        endpoint: `/plan/${planId}/planDocument/${fileName}`,
      });
      return true;
    },
    async removePlanInvestmentDocument(params: { planId: number; fileName: string }) {
      const { planId, fileName } = params;

      await coreAPI.authCall({
        method: "DELETE",
        endpoint: `/plan/${planId}/planInvestmentMenu/${fileName}`,
      });
      return true;
    },
    async uploadPlanDocument(params: { planId: number; file: File }) {
      const { planId, file } = params;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", planId.toString());
      formData.append("planDocumentFileName", file.name);

      await coreAPI.authCall({
        method: "POST",
        endpoint: `/plan/${planId}/planDocument/${file.name}`,
        body: formData,
      });
      return true;
    },

    async uploadInvestmentDocument(params: { planId: number; file: File }) {
      const { planId, file } = params;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", planId.toString());
      formData.append("planInvestmentMenuFileName", file.name);

      await coreAPI.authCall({
        method: "POST",
        endpoint: `/plan/${planId}/planInvestmentMenu/${file.name}`,
        body: formData,
      });
      return true;
    },
  };
  return api;
}
